import { client as trackerClient } from '../../http/client'

export default trackerClient
